import { ThemedIcon } from '@/design-system/icons';
import { NavItem } from '@/components';
import { IconName } from '@/design-system/icons/types';

export type NavItemWithIconName = Omit<NavItem, 'icon'> & {
  iconName?: IconName;
  children?: NavItemWithIconName[];
};

const navigationConfig: NavItemWithIconName[] = [
/*   {
    id: 'dashboard',
    labelKey: 'sidebar.dashboard',
    iconName: 'dashboard',
    children: [
      {
        id: 'dashboard-company',
        labelKey: 'sidebar.company',
        href: '/company',
      },
      {
        id: 'dashboard-tools',
        labelKey: 'sidebar.tools',
        href: '/dashboard/tools',
      },
    ],
  }, */
  {
    id: 'overview-headline',
    labelKey: 'sidebar.overview',
    isHeadline: true,
  },
  {
    id: 'devices',
    labelKey: 'sidebar.tools',
    iconName: 'wrench',
    children: [
      {
        id: 'devices-list',
        labelKey: 'sidebar.allDevices',
        href: '/devices',
      },
      {
        id: 'devices-assignment',
        labelKey: 'sidebar.deviceAssignment',
        href: '/device-assignment',
      },
    ],
  },
  {
    id: 'companies',
    labelKey: 'sidebar.companies',
    iconName: 'building',
    href: '/companies',
    children: [
      {
        id: 'companies-manufacturer',
        labelKey: 'sidebar.manufacturer',
        href: '/companies',
        query: {
          categories: 10
        }
      },
      {
        id: 'companies-oem',
        labelKey: 'sidebar.oemPartner',
        href: '/companies',
        query: {
          categories: 20
        }
      },
      {
        id: 'companies-distributor',
        labelKey: 'sidebar.distributor',
        href: '/companies',
        query: {
          categories: 30
        }
      },
      {
        id: 'companies-endcustomer',
        labelKey: 'sidebar.endCustomer',
        href: '/companies',
        query: {
          categories: 40
        }
      },
    ],
  },
  {
    id: 'user',
    labelKey: 'sidebar.user',
    href: '/users',
    iconName: 'user',
    requiredFeature: 'user.management',
  },
  {
    id: 'device-models',
    labelKey: 'sidebar.deviceModels',
    href: '/device-models',
    iconName: 'wrench',
    requiredFeature: 'device.management',
  },
  {
    id: 'administration',
    labelKey: 'sidebar.administration',
    iconName: 'settings',
    children: [
      {
        id: 'admin-my-company',
        labelKey: 'sidebar.company',
        href: '/admin/compani',
      },
      // {
      //   id: 'admin-my-devices',
      //   labelKey: 'sidebar.myDevices',
      //   href: '/admin/devices',
      // },
      // {
      //   id: 'admin-device-assignment',
      //   labelKey: 'sidebar.deviceAssignment',
      //   href: '/admin/assignment',
      // },
    ],
  },
  {
    id: 'documents',
    labelKey: 'sidebar.documents',
    href: '/documents',
    iconName: 'documents',
    requiredFeature: ['documents.admin', 'documents.read'],
  },
  {
    id: 'translations',
    labelKey: 'sidebar.translations',
    href: '/translations',
    iconName: 'languages',
    requiredFeature: 'translation.modify',
  },
];

// Resolves iconName to a themed icon element, recursively for children
export function mapToNavItems(items: NavItemWithIconName[]): NavItem[] {
  return items.map((item) => ({
    ...item,
    icon: item.iconName ? (
      <ThemedIcon name={item.iconName} className="size-4" />
    ) : undefined,
    children: item.children ? mapToNavItems(item.children) : undefined,
  }));
}

export const sidebarNavigation: NavItem[] = mapToNavItems(navigationConfig);
